import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Box, List, ListItem, Typography,
} from '@mui/material';
import { ExtendedPayload } from '../../../../redux/types';

type Props = {
  sectionComments: ExtendedPayload['sections'][0];
}

const MultiReviewComments: React.FC<Props> = ({
  sectionComments,
}: Props) => (
  <Box sx={{ my: '1rem' }}>
    <Typography variant="h5" fontWeight="bold"><FormattedMessage id="trialdetails.textBlockReviewTitle" /></Typography>
    {
      sectionComments
      && Object.entries(sectionComments)
        .map(([secKey, ob]) => (
          <Box key={secKey}>
            {
              ob.headline
              && ob.comments
              && ob.comments.length > 0
              && (
                <>
                  <Typography fontWeight="bold">
                    {ob.headline}
                  </Typography>
                  <List sx={{ my: 0, py: 0 }}>
                    {
                      ob.comments
                      && ob.comments
                        .map((o) => (
                          <ListItem key={`${o.key}${o.value}`}>
                            <Typography color="GrayText">
                              {o.label}
                            </Typography>
                          </ListItem>
                        ))
                    }
                  </List>
                </>
              )
            }
          </Box>
        ))
    }
  </Box>
);

export default MultiReviewComments;
